import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "title": "Zugang",
  "lead": "Weltweit beenden 88 % der Kinder die Grundschule, 78 % der Jugendlichen die untere Sekundarstufe und 59 % die obere Sekundarstufe."
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    blockquote: "blockquote",
    h2: "h2",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {Figure, Highlight, HighlightByIndex, IndicatorReference, PageLink, RelatedMaterial, ScrollyArea, ScrollySection, ScrollySticky, Tooltip} = _components;
  if (!Figure) _missingMdxReference("Figure", true);
  if (!Highlight) _missingMdxReference("Highlight", true);
  if (!HighlightByIndex) _missingMdxReference("HighlightByIndex", true);
  if (!IndicatorReference) _missingMdxReference("IndicatorReference", true);
  if (!PageLink) _missingMdxReference("PageLink", true);
  if (!RelatedMaterial) _missingMdxReference("RelatedMaterial", true);
  if (!ScrollyArea) _missingMdxReference("ScrollyArea", true);
  if (!ScrollySection) _missingMdxReference("ScrollySection", true);
  if (!ScrollySticky) _missingMdxReference("ScrollySticky", true);
  if (!Tooltip) _missingMdxReference("Tooltip", true);
  return _jsxs(_Fragment, {
    children: [_jsx(Figure, {
      id: "HERO_ACCESS"
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: "Das globale Versprechen, dass bis 2015 alle Kinder die Grundschule besuchen, wurde nicht erfüllt. Mit dem neuen Bildungsziel, SDG 4, werden noch höhere Maßstäbe gesetzt und gefordert, dass alle jungen Menschen bis 2030 die Sekundarschule abschließen. Um dieses Ziel zu erreichen, hätten alle Kinder im Einschulungsalter bereits 2018 eingeschult werden müssen. Tatsächlich lag die Einschulungsrate in Ländern mit niedrigem Einkommen jedoch nur bei 70 %."
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "besuch-der-vorschule",
      children: "Besuch der Vorschule"
    }), "\n", _jsx(IndicatorReference, {
      id: "4.2.2",
      children: _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Der Besuch der Vorschule"
        }), " bildet eine entscheidende Grundlage für den weiteren Bildungsweg von Kindern. In Ländern mit niedrigem Einkommen nehmen jedoch lediglich 44 % der Kinder im Jahr vor der Grundschule an einer Vorschulbildung teil."]
      })
    }), "\n", _jsx(_components.p, {
      children: "Seit dem Jahr 2000 haben die meisten Länder, einschließlich vieler der ärmsten, langsame, aber kontinuierliche Fortschritte beim Vorschulbesuch erzielt, doch viele hinken weiterhin hinterher. Weltweit erhalten aktuell 75 % der Kinder eine Vorschulerziehung, gegenüber 64 % im Jahr 2003."
    }), "\n", _jsx(_components.p, {
      children: "In einigen Ländern ist ein enormer Anstieg zu verzeichnen. In Kirgisistan zum Beispiel stieg die Teilnahmequote von 42 % im Jahr 2000 auf 87 % im Jahr 2024. In der Demokratischen Volksrepublik Laos stieg sie im gleichen Zeitraum von 10 % auf 89 %."
    }), "\n", _jsxs(_components.p, {
      children: ["Sowohl ", _jsx(HighlightByIndex, {
        index: "0",
        children: "Guatemala"
      }), " als auch ", _jsx(HighlightByIndex, {
        index: "1",
        children: "Niger"
      }), ", im Folgenden Beispiel aufgeführt, stieg die Zahl der Kinder in der Vorschulbildung stetig, auch wenn heute weiterhin große Unterschiede zwischen den beiden Gruppen bestehen."]
    }), "\n", _jsx(Figure, {
      id: "PREPRIM"
    }), "\n", _jsx(_components.h2, {
      id: "überalterung-der-teilnehmer",
      children: "Überalterung der Teilnehmer"
    }), "\n", _jsx(IndicatorReference, {
      id: "4.1.5",
      children: _jsxs(_components.p, {
        children: ["In vielen Ländern wird kaum thematisiert, dass mehr als ein Viertel der Grundschüler bei der Einschulung ", _jsx(_components.strong, {
          children: "überaltert"
        }), " sind, also deutlich älter als ihre Klassenkameraden. Dies hat tiefgreifende Auswirkungen auf ihre Zukunft, da es die Wahrscheinlichkeit erhöht, dass sie Klassen wiederholen, Prüfungen nicht bestehen und letztlich die Schule abbrechen."]
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Dieses Schaubild veranschaulicht die ", _jsx(_components.strong, {
        children: "Bildungsbeteiligung"
      }), " und zeigt das Alter von Kindern, Jugendlichen und jungen Erwachsenen, wenn sie die Vorschule, die Primarstufe, die untere und obere Sekundarstufe sowie die postsekundäre Bildung durchlaufen. Die Farbverteilung zeigt an, wie viele Kinder für ihre Bildungsstufe zu alt sind. Der grau schattierte Bereich zeigt den prozentualen Anteil der Kinder und Jugendlichen nach Alter, die nicht zur Schule gehen."]
    }), "\n", _jsxs(ScrollyArea, {
      children: [_jsx(ScrollySticky, {
        children: _jsx(Figure, {
          id: "OVERAGE"
        })
      }), _jsx(ScrollySection, {
        id: "KHM",
        children: _jsxs(_components.p, {
          children: ["In", _jsx(Highlight, {
            children: "Kambodscha"
          }), " sollten die meisten Kinder mit 10 Jahren eingeschult werden,\naber 21 % gehen in diesem Alter immer noch nicht in der Schule. Viele sind zu alt für\nihre Klasse. Beispielsweise gibt es 14-jährige,\ndie immer noch nicht die Grundschule besuchen."]
        })
      }), _jsx(ScrollySection, {
        id: "LBR",
        children: _jsxs(_components.p, {
          children: ["Die Überalterungsrate ist in den folgenden Ländern noch höher", " ", "\n", _jsx(Highlight, {
            children: "Liberia"
          }), " mit 28 % der 10-Jährigen in der Vorschule und\n20 % der 18-Jährigen besuchen in der Grundschule."]
        })
      }), _jsx(ScrollySection, {
        id: "NPL",
        children: _jsxs(_components.p, {
          children: [_jsx(Highlight, {
            children: "Nepal"
          }), " steht vor der gleichen Herausforderung"]
        })
      }), _jsx(ScrollySection, {
        id: "MWI",
        children: _jsxs(_components.p, {
          children: ["wie auch ", _jsx(Highlight, {
            children: "Malawi"
          }), "."]
        })
      })]
    }), "\n", _jsx(_components.h2, {
      id: "kinder-die-nicht-zur-schule-gehen",
      children: "Kinder, die nicht zur Schule gehen"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.1.4",
      children: [_jsxs(_components.p, {
        children: ["Weltweit gehen ", _jsx(_components.a, {
          href: "https://www.education-estimates.org",
          children: "272 Millionen Kinder und Jugendliche"
        }), " ", _jsx(_components.strong, {
          children: "nicht zur Schule"
        }), "."]
      }), _jsx(_components.p, {
        children: "Konflikte sind ein Hauptgrund für Stagnation. Leider führt der Konflikt auch dazu, dass die Verfügbarkeit und Qualität der Daten beeinträchtigt wird, obwohl einige Länder weiterhin Schätzungen bereitstellen. Um die jüngsten Auswirkungen von COVID-19 auf die Einschulungsraten genau bewerten zu können, ist es notwendig, langfristige und nachhaltigere Daten zu sammeln."
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "OOSRATE"
          })
        }), _jsx(ScrollySection, {
          id: "ECU,PRY",
          children: _jsxs(_components.p, {
            children: [_jsx(Highlight, {
              children: "Ecuador"
            }), " und ", _jsx(Highlight, {
              children: "Paraguay"
            }), " weisen sehr\nunterschiedliche Fortschritte auf. Im Bereich der unteren und oberen Sekundarstufe ist die\nZahl der Schulabbrecher in Ecuador stark gesunken,\nwährend sie in Paraguay gestiegen ist."]
          })
        }), _jsx(ScrollySection, {
          id: "ERI,ETH",
          children: _jsxs(_components.p, {
            children: [_jsx(Highlight, {
              children: "Eritrea"
            }), " und ", _jsx(Highlight, {
              children: "Äthiopien"
            }), " weisen ebenfalls\nsehr unterschiedliche Fortschritte auf. Die Nachwirkungen des Konflikts in Eritrea\nbeeinträchtigen den Zugang zur Bildung sichtlich, während in Äthiopien\nBildung in den Haushalt aufgenommen wurde\nwas zu einem raschen Rückgang der Zahl der Schulabbrecher führte."]
          })
        })]
      })]
    }), "\n", _jsx(_components.p, {
      children: "Ein weiterer Grund für die mangelnden Fortschritte beim Abbau der Zahl der Schulabbrecher ist das Bevölkerungswachstum."
    }), "\n", _jsxs(_components.p, {
      children: ["In den Ländern Subsahara Afrikas hat sich die ", _jsx(HighlightByIndex, {
        index: "2",
        children: "Bevölkerung im schulpflichtigen Alter"
      }), " zwischen 2000 und 2023 fast verdoppelt. Infolgedessen hat sich, auch wenn der ", _jsx(HighlightByIndex, {
        index: "0",
        children: "Anteil der Kinder, die nicht zur Schule gehen"
      }), " in diesem Zeitraum fast zur Hälfte zurück gegangen, die ", _jsx(HighlightByIndex, {
        index: "1",
        children: "Anzahl der Kinder, die nicht zur Schule gehen"
      }), " kaum verändert."]
    }), "\n", _jsx(Figure, {
      id: "OOSREL"
    }), "\n", _jsx(_components.h2, {
      id: "abschluss",
      children: "Abschluss"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.1.2",
      children: [_jsx(_components.p, {
        children: "Das obergestellte Ziel im Rahmen des SDG 4 ist der Abschluss der oberen Sekundarstufe und nicht nur die Einschulung. Und das, obwohl die Bildung in vielen Ländern nur bis zur unteren Sekundarstufe kostenlos und obligatorisch ist."
      }), _jsx(_components.p, {
        children: "Die Welt ist noch weit davon entfernt, das Ziel zu erreichen, allen Kindern bis zum festgelegten Zeitpunkt eine Grundschulbildung zu ermöglichen, ganz zu schweigen vom Abschluss der oberen Sekundarstufe. Bei den derzeitigen Trends werden im Jahr 2030 nur etwa sechs von zehn jungen Menschen einen Sekundarschulabschluss haben."
      }), _jsxs(_components.p, {
        children: ["Der Indikator bezieht sich auf Kinder, die Bildungsstufen bis zu 3 oder 5 Jahre später als das offizielle Abschlussalter abschließen können – dies kann definiert werden als ", _jsx(Tooltip, {
          title: "Rechtzeitiger Abschluss",
          content: "Kinder, die Bildungsstufen bis zu 3 oder 5 Jahre nach der letzten Klasse abschließen",
          children: "timelycompletion"
        }), ". Viele Kinder erhalten jedoch noch später einen Abschluss – dies kann als ", _jsx(Tooltip, {
          title: "Endgültiger Abschluss",
          content: "Kinder, die bis zum 8. Lebensjahr nach der letzten Schulstufe einen Abschluss erhalten",
          children: "ultimate completion"
        }), "definiert werden ."]
      }), _jsxs(_components.p, {
        children: ["In Mosambik beispielsweise besteht eine Lücke von fast 20 Prozentpunkten zwischen ", _jsx(HighlightByIndex, {
          index: "0",
          children: "rechtzeitige"
        }), " (49%) und ", _jsx(HighlightByIndex, {
          index: "1",
          children: "ultimativ"
        }), " Abschluss (66 %) im Primarbereich."]
      }), _jsx(Figure, {
        id: "COMPLETION"
      })]
    }), "\n", _jsx(_components.h2, {
      id: "schlussfolgerung",
      children: "Schlussfolgerung"
    }), "\n", _jsx(_components.p, {
      children: "Die Frage, wann Kinder eingeschult werden, in welchem Alter sie beginnen und ob sie ihren Abschluss erreichen oder nicht, sind entscheidende Themen für die Bildungspolitik."
    }), "\n", _jsxs(_components.p, {
      children: ["Die nächsten Themen auf dieser Website befassen sich mit der Frage, wie nahe wir dem Ziel sind ", _jsx(PageLink, {
        name: "equity",
        children: "Gleichheit"
      }), " in der Bildung zu erzielen, was Schüler sind ", _jsx(PageLink, {
        name: "learning",
        children: "lernen"
      }), ", wie gut ihre Bildung ist ", _jsx(PageLink, {
        name: "quality",
        children: "qualität"
      }), " ist, und wer ", _jsx(PageLink, {
        name: "Finanzen",
        children: "finanzen"
      }), " es."]
    }), "\n", _jsx(RelatedMaterial, {
      children: _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://www.education-estimates.org",
            children: "Visualizing Indicators of Education for the World (VIEW)"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://unesdoc.unesco.org/ark:/48223/pf0000382577",
            children: "New estimation confirms out-of-school population is growing in sub-Saharan Africa"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://resourcecentre.savethechildren.net/library/education-against-odds-meeting-marginalised-childrens-demands-quality-education",
            children: "Education above the odds – Save the Children"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "http://uis.unesco.org/sites/default/files/documents/ip61-combining-data-out-of-school-children-completion-learning-offer-more-comprehensive-view-sdg4.pdf",
            children: "Combining data on out-of-school children, Completion and learning to offer a more comprehensive view on SDG 4"
          })
        }), "\n"]
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
